import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ToastContext } from '@weezevent/nacre';

import { useTranslation } from 'react-i18next';

export default function DeleteModal({ show, sync, onClose, organizationId, subscriptionId, subscription }) {
    const { t } = useTranslation();

    const toast = React.useContext(ToastContext);

    const onDelete = React.useCallback(() => {
        subscription
            .delete({ organizationId, subscriptionId })
            .then(() => {
                sync({ cache: false, allow_cache: false });
                toast.success(t('ticket.common.cta.removed'));
            })
            .catch(() => {
                toast.error(t('ticket.webservice.list.modal.error'));
            })
            .finally(() => {
                onClose();
            });
    }, [subscription, organizationId, subscriptionId, onClose, sync, toast]);

    return (
        <Modal
            open={show}
            onClose={onClose}
            title={t('ticket.webservice.management-rules.modal.title')}
            submitButton={
                <Button primary onClick={onDelete}>
                    {t('ticket.common.cta.yes')}
                </Button>
            }
            cancelButton={<Button onClick={onClose}>{t('ticket.common.cta.no')}</Button>}
        >
            {t('ticket.webservice.management-rules.modal.body')}
        </Modal>
    );
}

DeleteModal.propTypes = {
    show: PropTypes.bool.isRequired,
    sync: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    organizationId: PropTypes.string.isRequired,
    subscription: PropTypes.object.isRequired
};
